import { FundsMoveListResponse } from 'src/api/FundsMoveListResponse';
import { FundMove } from 'src/api/FundMove';
import apiClient from './core/ApiClient'

const path = '/api/funds/moves';

const listAll = (): Promise<FundsMoveListResponse> => apiClient.get<FundsMoveListResponse>(path);
const find = (id: number): Promise<FundMove> => apiClient.get<FundMove>(`${path}/${id}`);
const add = (entry: FundMove): Promise<void> => apiClient.post<FundMove, void>(path, entry);
const update = (entry: FundMove): Promise<void> => apiClient.put<FundMove, void>(path, entry);
const remove = (id: number): Promise<void> => apiClient.delete<void>(`${path}/${id}`);

export const fundMoveService = {
    listAll,
    find,
    add,
    update,
    remove,
}
